export const getClasses = (array) => {
  return array.filter(Boolean).join(" ");
};
